import type { AxiosInstance } from 'axios'
import type { IContractType, IFactoryFunctionRequest, paginate } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'departureCategorys'

const getOne = (axios: IFactoryFunctionRequest<any, any>) => (processId: string) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${processId}`,
  })
}

// const filter = (axios: IFactoryFunctionRequest<paginate<Array<Pick<IContractType, '_id' | 'display'>>>, undefined>) => (options = {}) => {
//   return axios({
//     method: EMethod.get,
//     url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
//     query: options,
//   })
// }

const filter = (axios: IFactoryFunctionRequest<paginate<{ display: string }>, any>) => (query: { page: number; limit: number; search?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query,
  })
}

const updateDepartureCategory = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const createDepartureCategory = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const deleteDepartureCategory = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}


export default (axios: AxiosInstance) => ({
    getOne: getOne(useAxios(axios)),
    filter: filter(useAxios(axios)),
    update: updateDepartureCategory(useAxios(axios)),
    create: createDepartureCategory(useAxios(axios)),
    delete: deleteDepartureCategory(useAxios(axios)),
})
